import { useQuery } from "@tanstack/react-query";

import PortCodeService from "../services/port.service";
import { PortKeys } from "../util/queries";

const CACHE_TIME = 60 * 60 * 1000; // 1 hour

const useActionPorts = () => {
  interface GetAllPortsRequestProps {
    companyId?: number;
  }

  const getAllPorts = ({ companyId }: GetAllPortsRequestProps) => {
    return useQuery({
      queryKey: PortKeys.getAll([companyId]),
      queryFn: async () => {
        const response = await PortCodeService.getAll({
          include: JSON.stringify([
            { association: "companyPorts", required: true, where: { companyId } },
          ]),
        });

        if (response && response?.data) return response.data;

        return [];
      },

      enabled: !!companyId,
      staleTime: 10 * 60 * 1000, // 10 minutes
      cacheTime: CACHE_TIME,
    });
  };

  return {
    getAllPorts,
  };
};

export default useActionPorts;
